"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormShareModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const store_1 = require("../../store");
const org_department_selector_1 = require("../org.department.selector/org.department.selector");
const form_share_modal_style_1 = require("./form.share.modal.style");
(0, theme_1.addStyles)(form_share_modal_style_1.Style);
class FormShareModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, formRevision) {
        super(ctx);
        this.formRevision = formRevision;
        this.departmentSelector = new org_department_selector_1.OrgDepartmentSelector();
        this.addState(this.departmentSelector.inputState);
    }
    get nodes() {
        const formSummary = store_1.AppStore.FormSummary.get(this.formRevision);
        if (formSummary == null) {
            return spinner_1.Spinner.view();
        }
        return (0, mithril_1.m)('div', { className: form_share_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: form_share_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.FORM_SHARE_CONFIRM, { name: formSummary.displayname })),
                this.departmentSelector.view()
            ])
        ]);
    }
    submit() {
        const selectedDepartmentId = this.departmentSelector.selectedDepartmentId;
        if (selectedDepartmentId == null) {
            return null;
        }
        return services_1.Services.Form.share(this.formRevision, selectedDepartmentId);
    }
}
exports.FormShareModal = FormShareModal;
//# sourceMappingURL=form.share.modal.js.map